import { Component ,Input} from '@angular/core';
import { NgxCarousel } from 'ngx-carousel';

import { Product } from '../../entities/product.entities'
import { ProductService } from '../../services/product.service'
import { CartService } from '../../services/cart.service'

@Component({
    selector: 'item-detail',
    template: `
    <ngx-carousel
        (mouseover)="show('slide-button')"
        (mouseout)="hide()"
        [inputs]="carouselOne">

        <ngx-item NgxCarouselItem>
                <div class="col-lg-12 col-md-12 col-12 ">
                    <div class="row">
                        <div class="col-lg-12 col-md-10 col-12 py-2 mx-auto">
                            <img class="w-100" src="{{pathimg}}" alt="First slide"/>
                        </div>
                    </div>
                </div>
        </ngx-item>
        <ngx-item NgxCarouselItem *ngIf="pathimg2 != null">
                <div class="col-lg-12 col-md-12 col-12 ">
                    <div class="row">
                        <div class="col-lg-12 col-md-10 col-12 py-2 mx-auto">
                            <img class="w-100" src="{{pathimg2}}" alt="First slide"/>
                        </div>
                    </div>
                </div>
        </ngx-item>
        <ngx-item NgxCarouselItem *ngIf="pathimg3 != null">
                <div class="col-lg-12 col-md-12 col-12 ">
                    <div class="row">
                        <div class="col-lg-12 col-md-10 col-12 py-2 mx-auto">
                            <img class="w-100" src="{{pathimg3}}" alt="First slide"/>
                        </div>
                    </div>
                </div>
        </ngx-item>

        <button NgxCarouselPrev class='leftRs'
            [ngStyle]="hoverDivName ==='slide-button' ? showDiv : hideDiv">
            <img class="w-100" src="/assets/img/chevron_left_white.png" />
        </button>
        <button NgxCarouselNext class='rightRs'
            [ngStyle]="hoverDivName ==='slide-button' ? showDiv : hideDiv">
            <img class="w-100" src="/assets/img/chevron_right_white.png" />
        </button>
    </ngx-carousel>
  `,
  styles: [`
    .leftRs {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
        border-radius: 999px;
        left: 0;
        border: 0;
        background-color: rgba(0, 0, 0, 0.45);
        opacity:0;
        transition:all 0.5s;
    }
    .rightRs {
        position: absolute;
        margin: auto;
        top: 0;
        bottom: 0;
        width: 50px;
        height: 50px;
        box-shadow: 1px 2px 10px -1px rgba(0, 0, 0, .3);
        border-radius: 999px;
        right: 0;
        border: 0;
        background-color: rgba(0, 0, 0, 0.45);
        opacity:0;
        transition:all 0.5s;
    }
    li.active{
        background: rgba(27, 30, 33, 0.61);
    }
  `]
})
export class itemDetail {
    public carouselOne: NgxCarousel;
    public DataItem;
    public showSelect: boolean;
    public showAdd: boolean;
    private items: number[] = [];

    @Input() pathimg:any;
    @Input() pathimg2:any;
    @Input() pathimg3:any;
    constructor(private productService:ProductService) {
        console.log(this.pathimg2)
        this.carouselOne = {
            grid: { xs: 1, sm: 1, md: 1, lg: 1, all: 0 },
            slide: 1,
            speed: 400,
            interval: 4000,
            point: {
                visible: true
            },
            load: 2,
            touch: true,
            loop: true,
            custom: 'banner'
        }
    }
  
    // opacity ปุ่ม slide //
    hoverDivName;
    hideDiv = {opacity:'0'};
    showDiv= {opacity:'1'};

    show(divName:string){
        this.hoverDivName = divName;
    }

    hide(divName:string){
        this.hoverDivName = null;
    }
    


}


// WEBPACK FOOTER //
// D:/pokpak-v3/pokpak-v2/pokpak-ang/src/app/components/carousel/item-detail.ts